<template>
  <g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 4.18933L6.28783 13.9372L1 8.80961L3.2213 6.5189L6.12332 9.33298L12.6209 2.06299L15 4.18933Z"
      :fill="fill"
    />
  </g>
</template>

<script>
export default {
  props: {
    fill: {
      type: String,
      required: true
    }
  }
};
</script>
